import { lazy, memo, Suspense, useEffect } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { RoomLayout } from '@src/containers';
import { useFetchCTAs } from '@src/hooks/queries/useWebinarQuery';
import { useCtaStore, useWebinarRoomStore } from '@src/stores';

import useWebinarRoom from './useWebinarRoom';

const RoomScreen = lazy(() => import('@src/containers/RoomScreen'));
const WebinarAudioContainer = lazy(() => import('@src/containers/webinar/WebinarAudioContainer'));

const WebinarRoom = () => {
  useWebinarRoom();

  const { webinarId } = useWebinarRoomStore(useShallow((state) => ({ webinarId: state.webinarId })));
  const { setCtas } = useCtaStore(useShallow((state) => ({ setCtas: state.setCtas })));

  const { data } = useFetchCTAs(webinarId || undefined, true);

  useEffect(() => {
    if (data?.ctas) {
      setCtas(data.ctas);
    }
  }, [data?.ctas, setCtas]);

  return (
    <RoomLayout
      main={<RoomScreen />}
      extras={
        <Suspense fallback={null}>
          <WebinarAudioContainer />
        </Suspense>
      }
    />
  );
};

export default memo(WebinarRoom);
